import { Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { DataService, ObjectKeys } from '../../services/data.service';

import { DataService as CoreDataService, QueryColumn, QueryColumnSortOrder } from '@barthauer/abc/core/data';
import { GeoDsDocument, Measure, Project } from '@barthauer/custom/xmt-models';

@Injectable({
  providedIn: 'root',
})
export class DocumentService {
  public projectColumns: QueryColumn[] = [
    this.coreDataService.createQueryColumn('Id', 'Id', QueryColumnSortOrder.None),
    this.coreDataService.createQueryColumn('Designation', 'Designation', QueryColumnSortOrder.None),
  ];

  public documentColumns: QueryColumn[] = [
    this.coreDataService.createQueryColumn('Id', 'Id'),
    this.coreDataService.createQueryColumn('ParentId', 'ParentId'),
    this.coreDataService.createQueryColumn('FileName', 'FileName'),
    this.coreDataService.createQueryColumn('Designation', 'Designation'),
    this.coreDataService.createQueryColumn('Kind', 'Kind'),
    this.coreDataService.createQueryColumn('ParentObjectType', 'ParentObjectType'),
    this.coreDataService.createQueryColumn('SysDateInsert', 'Date'),
    this.coreDataService.createQueryColumn('!.Cast(xmtMeasure).Designation', 'MeasureDesignation'),
    this.coreDataService.createQueryColumn('!.Cast(xmtMeasure).SubProject.Designation', 'SubProjectDesignation'),
  ];

  public measureColumns = [
    this.coreDataService.createQueryColumn('Id', 'Id'),
    this.coreDataService.createQueryColumn('Designation', 'Designation'),
  ];

  public documentsNumber = signal(0);
  constructor(
    private dataService: DataService,
    private coreDataService: CoreDataService,
  ) {}
  public getProjectList = (): Observable<Project[]> => {
    const filterOpath = 'ParentId=' + "'" + sessionStorage.getItem('profileAddressId') + "'";
    return this.dataService.readObjects<Project[]>(ObjectKeys.PROJECT, this.projectColumns, filterOpath);
  };

  public getDocumentsByProjectId = (projectId: string): Observable<GeoDsDocument[]> => {
    const filterOpath = '!.Cast(xmtMeasure).SubProject.ParentId=' + "'" + projectId + "'";
    return this.dataService.readObjects<GeoDsDocument[]>(ObjectKeys.DOCUMENT, this.documentColumns, filterOpath);
  };

  public getAllDocument = (opath: string, columns?: QueryColumn[]): Observable<GeoDsDocument[]> => {
    return this.dataService.readObjects<GeoDsDocument[]>(
      ObjectKeys.DOCUMENT,
      columns ? columns : this.documentColumns,
      opath,
    );
  };

  public getMeasureWithDocuments = (): Observable<Measure[]> => {
    const filterOpath =
      '!.!.ParentId=' + "'" + sessionStorage.getItem('profileAddressId') + "'" + 'AND  Count(Documents) > 0';
    return this.dataService.readObjects<Measure[]>(ObjectKeys.MEASURE, this.measureColumns, filterOpath);
  };

  public deleteDocument = (documentId: string): Observable<GeoDsDocument> => {
    return this.dataService.deleteObject(ObjectKeys.DOCUMENT, documentId);
  };
}
